// app/javascript/components/shared/ui/Button.js
//
// Shared button primitive used across the V3 quote builder and the qline_groups
// (Ouvrages) library. Layout-agnostic — no margins, widths, or positioning;
// callers compose layout via the className escape hatch.
import React from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"

export const buttonVariants = cva(
  // Base — applied to every variant.
  "inline-flex items-center justify-center gap-1.5 font-medium rounded-md focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        primary:
          "bg-brand-500 hover:bg-brand-600 text-white border border-brand-500 hover:border-brand-600 focus:ring-[3px] focus:ring-brand-500/30",
        secondary:
          "bg-white hover:bg-slate-50 text-slate-700 hover:text-slate-900 border border-slate-300 focus:ring-[3px] focus:ring-slate-300/40",
        ghost:
          "bg-transparent hover:bg-slate-100 text-slate-700 hover:text-slate-900 border border-transparent",
        danger:
          "bg-rose-600 hover:bg-rose-700 text-white border border-rose-600 hover:border-rose-700 focus:ring-[3px] focus:ring-rose-500/30",
        "danger-ghost":
          "bg-transparent hover:bg-rose-50 text-rose-600 border border-transparent",
        // Dashed pill — used for "+ Ajouter X" affordances inside the builder.
        // Smaller paddings + pill shape; size variant just tunes height.
        "dashed-pill":
          "rounded-full border border-dashed border-slate-300 bg-transparent text-slate-500 hover:border-solid hover:border-brand-500 hover:text-brand-600 hover:bg-brand-50",
      },
      size: {
        xs: "h-7 px-2 text-[11px]",
        sm: "h-8 px-2.5 text-[12.5px]",
        md: "h-9 px-3 text-[13px]",
        lg: "h-10 px-3.5 text-sm",
      },
    },
    defaultVariants: { variant: "secondary", size: "md" },
  }
)

const Button = ({ variant, size, className, type = "button", ...props }) => (
  <button
    type={type}
    className={clsx(buttonVariants({ variant, size }), className)}
    {...props}
  />
)

export default Button
